import React, { useState, useRef, useCallback, useEffect } from "react";
import 'ag-grid-enterprise';
import AgGridTable from "../utilities/AgGridTable";
import ListPageHeader from "../utilities/ListPageHeader";
import { useNavigate } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { Button, Dialog, DialogActions, DialogTitle, Switch } from "@mui/material";
import DialogBox from "../utilities/DialogBox";
import { useMediaQuery, useTheme } from '@mui/material';


const FactoryVendorList
    = () => {
        
        const theme = useTheme();
        const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
        const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.factoryVendor}`;
        const [selectedRows, setSelectedRows] = useState([]);
        const [rowData, setRowData] = useState();
        const [gridApi, setGridApi] = useState(null);
        const perPage = 10;
        const gridRef = useRef();
        const navigate = useNavigate();
        const [error, setError] = useState("");
        const [open, setOpen] = useState(false);
        const [snackState, setSnackState] = useState(false);
        const [active, setActive] = useState(false);
        const [deleteDisable, setDeleteDisable] = useState(true);
        const [successMsg, setSuccessMsg] = useState();
        const [columnDefs, setColumnDefs] = useState([
            { field: 'id', enableRowGroup: true, headerName: 'Vendor Number' },
            { field: 'name', enableRowGroup: true, headerName: 'Vendor Name' },
            { field: 'shortKey', enableRowGroup: true },
            { field: 'active', enableRowGroup: true, cellRenderer: IconComponent },
            // { field: 'defaultAddress', enableRowGroup: true },
            // { field: 'currencyCode', enableRowGroup: true },
        ]);

        const refreshCache = useCallback(() => {
            gridRef.current.api.refreshCells();
        }, []);


        function IconComponent(props) {
            let bool = props?.data?.active
            return <Switch size="small" checked={bool} onClick={() => { handleSwitchClick(bool) }} />
        }
        console.log('active', active)

        const handleSwitchClick = (bool) => {
            setActive(bool);
            setOpen(true);
        }

        const onCellchangeHandle = (id) => {
            let elem = document.querySelector(`.${id}`)
            // const elem = ref.current;
            console.log("check elem ==> ", elem);
        }
        const handleSumbit = (e) => {
            selectedRows.map(async (row) => {

                try {
                    row.active = !row.active
                    const data = await OAuthService.updateData(url, row.id, row);
                    if (data) {
                        loadData();
                    }
                } catch (error) {
                    console.log(error)
                }

            })
            refreshCache();
            setOpen(false)
        }

        const handlePurge = (e) => {

            selectedRows.map(async (row) => {
                const id = row?.id;
                try {
                    await OAuthService.deleteData(url, id);
                    setSuccessMsg("Data deleted Successfully")
                    setSnackState(true);
                    loadData();
                } catch (error) {
                    console.log("eror", error);
                    setError(error.message);
                }
            })
        };

        const onGridReady = useCallback((params) => {
            setGridApi(params.api);
            var columnToolPanel = gridRef.current.api.getToolPanelInstance('columns');
            columnToolPanel.expandColumnGroups();
        }, []);

        const onBtExport = useCallback(() => {
            const params = {
                fileName: 'FactoryVendors.xlsx',
                sheetName: 'Factory Vendors'
            }
            gridRef.current.api.exportDataAsExcel(params);
        }, []);

        const loadData = async () => {
            try {
                const list = await OAuthService.getList(url + `?size=1000&sort=id,asc`);
                let factoryData = list.data?._embedded?.factoryVendors;
                setRowData(factoryData);
            } catch (error) {
                setError(error.message);
            }
        }

        useEffect(() => {
            if (gridApi) {
                loadData();
            }
        }, [gridApi]);

        const onSelectionChanged = (params) => {

            setSelectedRows(params.api.getSelectedRows());
        }

      
        const goToRoleEdit = useCallback(
            (data) => {
              const id = data?._links?.self?.href.split('/').pop();
              if (id) {
                navigate('/editFactoryVendor/' + id);
              }
            },
            [navigate],
          );
        
          const onRowDoubleClicked = (params) => {
            if (isMobile) return; 
            goToRoleEdit(params?.data);
          };
        
          const onRowClicked = (params) => {
            if (!isMobile) return; 
            goToRoleEdit(params?.data);
          };
        useEffect(() => {
            if (selectedRows.length > 0) {
                setDeleteDisable(false)
            } else {
                setDeleteDisable(true)
            }
        }, [selectedRows])
        const handleClose = () => {
            setOpen(false)
        }
        return (
            <>
                <ListPageHeader
                    componentName="FactoryVendor"
                    onBtExport={onBtExport}
                    handlePurge={handlePurge}
                    addPageLink="/addVendor"
                    pageName="Factory Vendor List"
                    error={error}
                    successMsg={successMsg}
                    deleteDisable={deleteDisable}
                    snackState={snackState}
                    gridRef={gridRef}
                />
                <div className="h-full">
                    <AgGridTable
                        frameworkComponents={{
                            iconComponent: IconComponent
                        }}
                        rowData={rowData}
                        columnDefs={columnDefs}
                        onGridReady={onGridReady}
                        onSelectionChanged={onSelectionChanged}
                        onRowDoubleClicked={onRowDoubleClicked}
                        gridRef={gridRef}
                        paginationPageSize={perPage}
                        cacheBlockSize={perPage}
                        onRowClicked={onRowClicked}
                        // onCellValueChanged={onCellChangeHandle}
                        saveGridStateName={'factoryVendorList'}
                    />
                </div>
                <DialogBox
                    open={open}
                    handleClose={handleClose}
                    handleSumbit={handleSumbit}
                    title={!active ? "Active factory vendor" : "Deactive factory vendor"}
                />
            </>
        );
    }

export default FactoryVendorList
